module.exports = __webpack_public_path__ + "img/right-arrow.bde9bb28.svg";